import { InputNumber } from 'antd';
import type { InputProps } from './types';

export function NumberInput({ field, value, onChange, autoFocus }: InputProps) {
  return (
    <InputNumber
      value={value as number | null}
      onChange={(v) => onChange(v ?? null)}
      placeholder={field.placeholder}
      required={field.required}
      disabled={field.disabled}
      autoFocus={autoFocus}
      className={field.inputClassName}
      style={{ width: '100%' }}
    />
  );
}
